export enum PropertyTabs {
  TIMELINE,
  AGENTS,
  AUTOMATIONS,
  INTEGRATIONS,
  TOUR_HOUR,
  GALLERY,
  HUB,
  LOCK_HISTORIES,
  SMART_LOCK,
  WIFI_THERMOSTAT
}
